// extracted by mini-css-extract-plugin
export default {"submitButton":"tYdmx"};